const authUrlEnum = {
  development: "https://test-www.fotor.com/",
  testStaging: "https://test-www.fotor.com/",
  prodStaging: "https://test-www.fotor.com/",
  production: "https://www.fotor.com/"
};

module.exports = authUrlEnum[process.env.SERVER_ENV] || authUrlEnum["development"];
